'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MessengerSendToMessenger = function (_Component) {
  _inherits(MessengerSendToMessenger, _Component);

  function MessengerSendToMessenger() {
    _classCallCheck(this, MessengerSendToMessenger);

    return _possibleConstructorReturn(this, (MessengerSendToMessenger.__proto__ || Object.getPrototypeOf(MessengerSendToMessenger)).apply(this, arguments));
  }

  _createClass(MessengerSendToMessenger, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (document.getElementById('facebook-jssdk')) {
        return;
      }
      this.setFbAsyncInit();
      this.loadSdkAsynchronously();
    }
  }, {
    key: 'setFbAsyncInit',
    value: function setFbAsyncInit() {
      var _props = this.props,
          appId = _props.appId,
          autoLogAppEvents = _props.autoLogAppEvents,
          xfbml = _props.xfbml,
          version = _props.version;

      window.fbAsyncInit = function () {
        window.FB.init({
          appId: appId,
          autoLogAppEvents: autoLogAppEvents,
          xfbml: xfbml,
          version: 'v' + version
        });
      };
    }
  }, {
    key: 'loadSdkAsynchronously',
    value: function loadSdkAsynchronously() {
      var _props2 = this.props,
          language = _props2.language,
          debug = _props2.debug;
      /* eslint-disable */

      (function (d, s, id) {
        var js,
            fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) {
          return;
        }
        js = d.createElement(s);
        js.id = id;
        js.src = 'https://connect.facebook.net/' + language + '/sdk' + (debug ? '/debug' : '') + '.js';
        fjs.parentNode.insertBefore(js, fjs);
      })(document, 'script', 'facebook-jssdk');
      /* eslint-enable */
    }
  }, {
    key: 'createMarkup',
    value: function createMarkup() {
      var _props3 = this.props,
          pageId = _props3.pageId,
          appId = _props3.appId,
          dataRef = _props3.dataRef,
          color = _props3.color,
          size = _props3.size,
          enforceLogin = _props3.enforceLogin,
          ctaText = _props3.ctaText;


      var dataRefAttribute = dataRef !== undefined ? 'data-ref="' + dataRef + '"' : '';

      var ctaTextAttribute = ctaText !== undefined ? 'cta_text="' + ctaText + '"' : '';

      return {
        __html: '<div\n        class="fb-send-to-messenger"\n        page_id="' + pageId + '"\n        messenger_app_id="' + appId + '"\n        color="' + color + '"\n        size="' + size + '"\n        enforce_login="' + enforceLogin + '"\n        ' + dataRefAttribute + '\n        ' + ctaTextAttribute + '\n      ></div>'
      };
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement('div', { dangerouslySetInnerHTML: this.createMarkup() });
    }
  }]);

  return MessengerSendToMessenger;
}(_react.Component);

MessengerSendToMessenger.propTypes = {
  pageId: _propTypes2.default.string.isRequired,
  appId: _propTypes2.default.string.isRequired,

  dataRef: _propTypes2.default.string,
  color: _propTypes2.default.string,
  size: _propTypes2.default.string,
  enforceLogin: _propTypes2.default.bool,
  ctaText: _propTypes2.default.oneOf(['GET_THIS_IN_MESSENGER', 'RECEIVE_THIS_IN_MESSENGER', 'SEND_THIS_TO_ME', 'GET_CUSTOMER_ASSISTANCE', 'GET_CUSTOMER_SERVICE', 'GET_SUPPORT', 'LET_US_CHAT', 'SEND_ME_MESSAGES', 'ALERT_ME_IN_MESSENGER', 'SEND_ME_UPDATES', 'MESSAGE_ME', 'LET_ME_KNOW', 'KEEP_ME_UPDATED', 'TELL_ME_MORE', 'SUBSCRIBE_IN_MESSENGER', 'SUBSCRIBE_TO_UPDATES', 'GET_MESSAGES', 'SUBSCRIBE', 'GET_STARTED_IN_MESSENGER', 'LEARN_MORE_IN_MESSENGER', 'GET_STARTED', 'SEND_TO_MESSENGER']),
  autoLogAppEvents: _propTypes2.default.bool,
  xfbml: _propTypes2.default.bool,
  version: _propTypes2.default.string,
  language: _propTypes2.default.string,
  debug: _propTypes2.default.bool
};
MessengerSendToMessenger.defaultProps = {
  dataRef: undefined,
  color: 'blue',
  size: 'large',
  enforceLogin: false,
  ctaText: undefined,
  autoLogAppEvents: true,
  xfbml: true,
  version: '2.11',
  language: 'en_US',
  debug: false
};
exports.default = MessengerSendToMessenger;